import { render } from "./YourySubmissionIndex.vue?vue&type=template&id=411e68f3"
import script from "./YourySubmissionIndex.vue?vue&type=script&lang=js"
export * from "./YourySubmissionIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/youry.co/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__